import RestrictedWordsTab from '../RestrictedWordsTab'

export function RestrictedWordsSettings() {
  return (
    <>
      <h2 className="text-lg text-muted-foreground mb-4">Restricted Words</h2>
      <RestrictedWordsTab />
    </>
  )
}
